import { render, staticRenderFns } from "./default.vue?vue&type=template&id=4b00b371"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsTheBackToTop: require('/usr/src/nuxt-app/components/elements/TheBackToTop.vue').default})
